import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { KAFKA_PATHS } from './paths';

/** Знак Apache Kafka, контур из Simple Icons (CC0). */
export const KafkaIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {KAFKA_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
